// extracted by mini-css-extract-plugin
module.exports = {"no_access":"styles_no_access__X9K6c"};